<template>
  <div class="blue merida">
    <div id="board" class="cg-board-wrap"></div> </br>
    <div>
      <button @click="takeback()">Back</button>
      &nbsp;&nbsp;
      <button @click="toggleOrientation()">Flip</button>
    </div>
    <div style="margin:5px 0 10px 0;font-size:1.2em">
      Q = {{ this.Q + (isPrime ? ' OK' : '') }}
    </div>
  </div>
</template>

<script>
// No need for more primes (see "computeQ" method)
const PRIMES = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43];

const ROOK_STEPS = [ [-1, 0], [1, 0], [0, -1], [0, 1] ];
const BISHOP_STEPS = [ [-1, -1], [1, -1], [-1, 1], [1, 1] ];
const KNIGHT_STEPS =
  [ [-2, -1], [-2, 1], [-1, -2], [-1, 2], [1, -2], [1, 2], [2, -1], [2, 1] ];

// Helper to check if coordinates (x, y) are inside board
function OnBoard (x, y) {
  return (x >= 0 && y >= 0 && x < 8 && y < 8);
}

import { Chessground } from 'chessground';
export default {
  name: 'chessboard',
  props: {
    fen: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      Q: 0,
      isPrime: false,
      moves: [],
      board: null,
    };
  },
  watch: {
    fen: function() {
      this.loadPosition();
    },
  },
  methods: {
    loadPosition() {
      this.board = Chessground(document.getElementById("board"), {
        fen: this.fen,
        events: {
          move: (orig, dest, capturedPiece) => {
            this.moves.push({
              orig: orig,
              dest: dest,
              capturedPiece: capturedPiece,
            });
          },
          change: () => this.computeQ()
        }
      });
      this.moves = [];
      this.computeQ();
    },
    takeback() {
      const move = this.moves.pop();
      if (!move) return;
      const pieces = this.board.state.pieces;
      let piecesDiff = new Map();
      piecesDiff.set(move.orig, pieces.get(move.dest));
      if (!!move.capturedPiece)
        piecesDiff.set(move.dest, move.capturedPiece);
      else
        piecesDiff.set(move.dest, undefined);
      this.board.setPieces(piecesDiff);
      this.computeQ();
    },
    toggleOrientation() {
      this.board.toggleOrientation();
    },
    computeQ() {
      const pieces = this.board.state.pieces;
      this.Q = 0;
      for (let square of pieces.keys()) {
        // Square is easier to process numerically
        const [x, y] =
          [parseInt(square[1], 10) - 1, square[0].charCodeAt(0) - 97];
        const curPiece = pieces.get(square);
        const [role, color] = [curPiece.role, curPiece.color];
        if (role === 'pawn') {
          const forward = (color === 'white' ? 1 : -1);
          for (let shift of [-1, 1]) {
            if (OnBoard(x + forward, y + shift))
              this.Q++;
          }
        }
        else if (['knight', 'king'].includes(role)) {
          const steps =
            role === 'knight'
              ? KNIGHT_STEPS
            : ROOK_STEPS.concat(BISHOP_STEPS);
          for (let s of steps) {
            if (OnBoard(x + s[0], y + s[1]))
              this.Q++;
          }
        }
        else {
          let steps = ROOK_STEPS;
          if (role === 'queen')
            steps = steps.concat(BISHOP_STEPS);
          else if (role === 'bishop')
            steps = BISHOP_STEPS;
          for (let s of steps) {
            let [i, j] = [x + s[0], y + s[1]];
            while (
              OnBoard(i, j) &&
              !(pieces.get(String.fromCharCode(j + 97) + (i+1)))
            ) {
              this.Q++;
              i += s[0];
              j += s[1];
            }
            if (OnBoard(i, j))
              this.Q++;
          }
        }
      }
      // 32 * 64 controlled squares max (unreachable)
      // => no need to check primes above sqrt(2048)
      this.isPrime = PRIMES.every(p => this.Q % p !== 0);
    },
  },
  mounted () {
    this.loadPosition();
  },
};
</script>
